import { useCallback } from 'react';
import { ProofForBox } from 'src/components/DUP/molecules/WizardUpload/useWizardUpload';
import { HEAP_SNAX_EVENT_PREFIX } from 'src/constants/heap';
import { Account } from 'src/types/applicantExperienceApi';

const formatEventName = (eventName: string) => {
  return `${HEAP_SNAX_EVENT_PREFIX}${eventName}`;
};

export const useTelemetry = () => {
  const addUserProperties = useCallback((properties: CustomUserProperties) => {
    if (window.heap) {
      window.heap.addUserProperties(properties);
    }
    if (window.pendo) {
      window.pendo.identify({
        visitor: {
          id: properties.id ?? 'VISITOR-UNIQUE-ID',
          ...properties
        }
      });
    }
  }, []);

  const clearEventProperties = useCallback(() => {
    if (window.heap) {
      window.heap.clearEventProperties();
    }
  }, []);

  const trackPageView = useCallback((title: string) => {
    if (window.heap) {
      window.heap.trackPageview({ title: title });
    }
  }, []);

  const trackFileUploads = useCallback((successfulUploads: number, failedDocs: ProofForBox[]) => {
    if (successfulUploads) {
      const successEvent = {
        status: 'success',
        count: successfulUploads
      };
      if (window.heap) {
        window.heap.track(formatEventName('document_upload'), successEvent);
      }
      if (window.pendo) {
        window.pendo.track(formatEventName('document_upload'), successEvent);
      }
    }
    if (failedDocs.length) {
      const failedEvent = {
        status: 'error',
        count: failedDocs.length
      };
      if (window.heap) {
        window.heap.track(formatEventName('document_upload'), failedEvent);
      }
      if (window.pendo) {
        window.pendo.track(formatEventName('document_upload'), failedEvent);
      }
    }
  }, []);

  const trackAccountsConnected = useCallback((accConnected: Account[] | null) => {
    if (window.heap && accConnected && accConnected.length) {
      if (window.heap) {
        window.heap.track(formatEventName('connected_payroll'));
      }
      if (window.pendo) {
        window.pendo.track(formatEventName('connected_payroll'));
      }
    }
  }, []);

  return {
    addUserProperties,
    clearEventProperties,
    trackPageView,
    trackFileUploads,
    trackAccountsConnected
  };
};
